import classes from './MainStatusFilters.module.css';
import { useTranslation } from 'react-i18next';
import { Employee } from '../../../contexts/interfaces';

interface FilterProps {
    activePermits: Employee[],
    expiringPermits: Employee[],
    expiredPermits: Employee[],
    unfinishedForms: Employee[],
    waitingForms: Employee[],
    selectedFilter: string
    setSelectedFilter: (val: string) => void,
    searchEmployeeId: number | undefined
};

const MainStatusFilters = ({
    activePermits,
    expiringPermits,
    expiredPermits,
    unfinishedForms,
    waitingForms,
    selectedFilter,
    setSelectedFilter,
    searchEmployeeId
}: FilterProps) => {

    const { t } = useTranslation();

    return (
        <div className={classes.filterRow}>
            <div
                className={selectedFilter === "activePermits" ?
                    classes.filterItemContainerSelected :
                    classes.filterItemContainer}
                onClick={() => setSelectedFilter("activePermits")}
            >
                <div className={classes.filterDotUpToDate} />
                <div className={classes.filterText}>
                    {`${t('mainStatusFilters.activePermits')} (${activePermits.filter(perm => searchEmployeeId ? perm.employeeId === searchEmployeeId : true).length})`}
                </div>
            </div>
            <div
                className={selectedFilter === "expiringPermits" ?
                    classes.filterItemContainerSelected :
                    classes.filterItemContainer}
                onClick={() => setSelectedFilter("expiringPermits")}
            >
                <div className={classes.filterDotSoonOutOfDate} />
                <div className={classes.filterText}>
                    {`${t('mainStatusFilters.expiringPermits')} (${expiringPermits.filter(perm => searchEmployeeId ? perm.employeeId === searchEmployeeId : true).length})`}

                </div>
            </div>
            <div
                className={selectedFilter === "expiredPermits" ?
                    classes.filterItemContainerSelected :
                    classes.filterItemContainer}
                onClick={() => setSelectedFilter("expiredPermits")}
            >
                <div className={classes.filterDotOutOfDate} />
                <div className={classes.filterText}>
                    {`${t('mainStatusFilters.expiredPermits')} (${expiredPermits.filter(perm => searchEmployeeId ? perm.employeeId === searchEmployeeId : true).length})`}
                </div>
            </div>
            <div
                className={selectedFilter === "unfinishedForms" ?
                    classes.filterItemContainerSelected :
                    classes.filterItemContainer}
                onClick={() => setSelectedFilter("unfinishedForms")}
            >
                <div className={classes.filterDotUnfinished} />
                <div className={classes.filterText}>
                    {`${t('mainStatusFilters.unfinishedForms')} (${unfinishedForms.filter(form => searchEmployeeId ? form.employeeId === searchEmployeeId : true).length})`}
                </div>
            </div>
            <div
                className={selectedFilter === "waitingForms" ?
                    classes.filterItemContainerSelected :
                    classes.filterItemContainer}
                onClick={() => setSelectedFilter("waitingForms")}
            >
                <div className={classes.filterDotWaiting} />
                <div className={classes.filterText}>
                    {`${t('mainStatusFilters.waitingForms')} (${waitingForms.filter(form => searchEmployeeId ? form.employeeId === searchEmployeeId : true).length})`}
                </div>
            </div>
        </div>
    )
};

export default MainStatusFilters;